import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const SurveyKpiGrid = ({ overview }) => {
  const count = (value) => Number(value || 0).toLocaleString();
  const kpis = [
    { key: "eligible", label: "Currently Eligible", value: count(overview.eligibleLeadCount), tooltip: "Calculated from the survey’s current target segmentation." },
    { key: "delivered", label: "Delivered", value: count(overview.deliveredLeadCount) },
    { key: "answered", label: "Answered", value: count(overview.answeredLeadCount), emphasis: true },
    { key: "pending", label: "Pending", value: count(overview.pendingLeadCount) },
    { key: "rate", label: "Response Rate", value: `${Number(overview.responseRate || 0).toFixed(2)}%`, emphasis: true },
  ];
  return <div className="survey-engine-kpi-grid">{kpis.map((kpi) => <div className={`survey-engine-kpi ${kpi.emphasis ? "emphasis" : ""}`} key={kpi.key}><span>{kpi.label}{kpi.tooltip && <OverlayTrigger placement="top" overlay={<Tooltip id="survey-eligible-tooltip">{kpi.tooltip}</Tooltip>}><i className="fa fa-info-circle survey-engine-kpi-info" aria-label={kpi.tooltip} tabIndex={0} /></OverlayTrigger>}</span><strong>{kpi.value}</strong></div>)}</div>;
};

export default SurveyKpiGrid;
